import { ELetterPreview } from '@account-root/account-react/src/containers/ARModule/Hooks/ELetterTemplate/ELetterPreview';
import { groupItemDataForPreview } from '@account-root/account-react/src/containers/ARModule/Hooks/ELetterTemplate/ELetterService';
import { Footer } from '@ifca-root/react-component/src/components/Footer/Footer';
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader';
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper';
import Loading from '@ifca-root/react-component/src/components/Loading/Loading';
import { useMediaQuery } from '@ifca-root/react-component/src/helpers/PDFFormatter/mediaSize';
import ShareIcon from '@material-ui/icons/Share';
import { Pagination } from '@material-ui/lab';
import { Group, drawDOM, exportPDF } from '@progress/kendo-drawing';
import { ErrorDialog } from 'components/Dialog/ErrorDialog';
import ShareDialog from 'components/Dialog/ShareDialog';
import saveAs from 'file-saver';
import { useMobilePDFZoom } from 'helpers/Hooks/useMobilePDFZoom';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import {
  useGetShareAttachmentMutation,
  useGetUsersByAccountAndSoftwareQuery,
} from '../../generated/graphql';
import GPBodyTemplate from './BodyTemplate/GPBodyTemplate';
import './PDFStyle.scss';
import { useGPQueries } from './useGPQueries';

export const PDFPreviewGP = (_props: any) => {
  const user = JSON.parse(localStorage.getItem('loggedInUser'));
  const [width] = useMediaQuery();

  let history = useHistory();
  const { styles } = useMobilePDFZoom();

  const {
    CompanyID,
    PRHeaderID,
    POHeaderID,
    GRTNHeaderID,
    DOHeaderID,
    RFQHeaderID,
  }: any = useParams();
  const { accountType, docType, backPath } = _props;

  const [errMessage, setErrMessage] = useState(null);
  const [errDialog, setErrDialog] = useState(false);
  const [isDataHandled, setIsDataHandled] = useState<boolean>(false);
  const [pageLength, setPageLength] = useState(1);

  let fontSize;
  if (width < 769) fontSize = 7;
  else fontSize = 10;

  let descriptionSize;
  if (width < 769) {
    descriptionSize = 6;
  } else {
    descriptionSize = 9;
  }

  let fontStyle;
  fontStyle = { fontSize: fontSize, textAlign: 'center' };

  let routeSegments;
  let title;
  let smTitle;
  let DocumentID;
  let itemName;
  let eLetter = false;
  switch (accountType) {
    case '/':
      smTitle = 'General Purchases';
      switch (docType) {
        // PO and PR
        case 'generate-po-from-pr':
          routeSegments = 'Purchase Order';
          title = 'PURCHASE ORDER';
          DocumentID = POHeaderID;
          itemName = 'POItem';
          eLetter = true;
          break;
        case 'direct-po':
          routeSegments = 'Purchase Order';
          title = 'PURCHASE ORDER';
          DocumentID = POHeaderID;
          itemName = 'POItem';
          eLetter = true;
          break;
        case 'centralised-po':
          routeSegments = 'Purchase Order';
          title = 'PURCHASE ORDER';
          DocumentID = POHeaderID;
          itemName = 'POItem';
          eLetter = true;
          break;
        case 'purchase-requisition':
          routeSegments = 'Purchase Requisition';
          title = 'PURCHASE REQUISITION';
          DocumentID = PRHeaderID;
          itemName = 'PRItem';
          eLetter = true;
          break;
        case 'rfq':
          routeSegments = 'Request for Quotation';
          title = 'QUOTATION';
          DocumentID = RFQHeaderID;
          itemName = 'RFQItem';
          break;
        // GRTN and GRN
        case 'good-return-note':
          routeSegments = 'Goods Return Note';
          title = 'GOODS RETURN NOTE';
          DocumentID = GRTNHeaderID;
          itemName = 'GRTNHeaderItem';
          eLetter = true;
          break;
        case 'delivery-order':
          routeSegments = 'Goods Receive Note';
          title = 'GOODS RECEIVE NOTE';
          DocumentID = DOHeaderID;
          itemName = 'DOItem';
          eLetter = true;
          break;
        default:
          break;
      }
      switch (backPath) {
        case 'purchase-requisition':
          break;
        case 'direct-po':
          break;
      }
      break;
  }

  const {
    queryLoading,
    listData,
    primaryKey,
    templateBody,
    errMessage: errMsg,
    errDialog: errDia,
    setErrDialog: setErrDia,
  } = useGPQueries({ docType, CompanyID, transactionID: DocumentID });

  let previewDetail;

  if (docType === 'direct-po') {
    if (listData?.length > 0 && !!templateBody) {
      const groupKeys = [
        'ItemDescription',
        'ItemRemark',
        'Department',
        'UOM',
        'UnitPrice',
        'DeptCd',
        'DeptCtNm',
        'DeptCtCd',
      ];

      const dataItem = listData[0]?.POItem?.map(el => {
        return {
          ItemDescription: el?.Item?.Name,
          ItemRemark: el?.Remarks,
          Department: el?.CostCentre?.Name,
          DeptCd: el?.CostCentre?.Code,
          DeptCtNm: el?.CostCentre?.FirstCostCentre?.Name,
          DeptCtCd: el?.CostCentre?.FirstCostCentre?.Code,
          UOM: el?.UOM?.Code,
          Quantity: Number(el?.OrderedQty),
          UnitPrice: Number(el?.UnitPrice),
          BaseAmt: Number(el?.BaseAmt),
          TaxAmt: Number(el?.TaxAmt),
          TotalAmt: Number(el?.TotalAmt),
          ItemTaxInfo: el?.ItemTaxInfo,
        };
      });

      const groupDataItem = groupItemDataForPreview({
        templateBody,
        groupKeys,
        dataItem,
      });

      previewDetail = listData[0];
      if (groupDataItem?.length > 0) {
        previewDetail['itemList'] = groupDataItem;
        previewDetail[itemName] = [];
      }
    }
  } else {
    previewDetail = {
      ...listData[0],
      itemList: listData[0]?.[itemName],
      [itemName]: [],
    };
  }

  interface InfoTemplateRight {
    title: string;
    data: string;
  }
  const InfoTemplateRight = ({ title, data }: InfoTemplateRight) => {
    return (
      <div style={{ paddingLeft: '20%' }}>
        <div style={{ width: '40%', display: 'inline-flex' }}>{`${title}`}</div>
        <div style={{ width: '10%', display: 'inline-flex' }}>:</div>
        <div style={{ width: '50%', display: 'inline-flex' }}>{data}</div>
      </div>
    );
  };

  const {
    loading: UserLoading,
    data: { getUsersByAccountAndSoftware } = {
      getUsersByAccountAndSoftware: [],
    },
  } = useGetUsersByAccountAndSoftwareQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15);
      setErrMessage(error);
      setErrDialog(true);
    },
  });

  // ========== Page definition ==========

  const [page, setCurrentPage] = useState<number>(0);

  // ========== Threshold definition ==========
  let totalItems = previewDetail?.['itemList']?.length;

  let threshold;
  if (totalItems > 10) {
    threshold = 10;
  } else {
    threshold = 0;
  }

  // ========== Remap Data for item list ==========
  const [remapData, setRemapData] = useState(null);

  const separateThreshold = input => {
    let temp = [];
    let noChange = [];
    let tempItem = [];

    previewDetail?.['itemList']?.map((v, i) => {
      tempItem.push({ ...v, index: i + 1 });
      if ((i + 1) % threshold === 0) {
        temp.push({ ...input, ['itemList']: tempItem });
        tempItem = [];
      } else if (previewDetail?.['itemList']?.length === i + 1) {
        temp.push({ ...input, ['itemList']: tempItem });
      }
    });
    noChange.push(temp);
    temp = [];
    return setRemapData(noChange.flat());
  };

  useEffect(() => {
    if (
      !!previewDetail &&
      !!previewDetail?.['itemList'] &&
      (remapData === null || remapData?.length === 0)
    ) {
      separateThreshold(previewDetail);
    }
  }, [previewDetail]);

  /// ========== kendo-drawing PDF Download ===========
  const dataURItoFile = (dataurl, filename) => {
    dataurl.replace('data:application/pdf;base64,', '');
    var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  };

  const onPrint = () => {
    let element = document.getElementById('pdf-data-print');

    drawDOM(element, {
      paperSize: [794, 1123], // custom size in Kendo units (pt/px)
      scale: 1,
      margin: {
        top: '0mm',
        bottom: '0mm',
        left: '0mm',
        right: '0mm',
      },
      forcePageBreak: '.page-break',
    })
      .then((group: Group) => exportPDF(group))
      .then(dataURI => {
        let fileObject = dataURItoFile(
          dataURI,
          `${title} (${previewDetail?.DocNo}).pdf`,
        );
        saveAs(fileObject, `${title} (${previewDetail?.DocNo}).pdf`);
      });
  };

  const onShare = async (filename = 'document.pdf') => {
    const element = document.getElementById('pdf-data-print');

    const group = await drawDOM(element, {
      paperSize: [794, 1123], // custom size in Kendo units (pt/px)
      scale: 1,
      margin: {
        top: '0mm',
        bottom: '0mm',
        left: '0mm',
        right: '0mm',
      },
      forcePageBreak: '.page-break',
    });

    const dataURI = await exportPDF(group);

    // Convert Base64 → Blob
    const byteString = atob(dataURI.split(',')[1]);
    const mimeString = 'application/pdf';
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    const blob = new Blob([ab], { type: mimeString });

    // ✅ Return a File object with PDF type
    const file = new File([blob], filename, { type: mimeString });
    return file;
  };

  /* ========================================= */
  /* DOCS THAT IS SAVED AS PDF WHICH IS HIDDEN */
  /* ========================================= */

  const pdfToPrint = () => {
    return (
      <>
        <div style={{ position: 'fixed', left: `-2000px` }}>
          <div id={'pdf-data-print'}>
            {previewDetail &&
              (eLetter === true ? (
                !!remapData && remapData?.length > 0 ? (
                  remapData?.map((v, index) => {
                    return (
                      <ELetterPreview
                        fontStyle={fontStyle}
                        title={title}
                        previewDetail={v}
                        accountType={accountType}
                        docType={docType}
                        itemName={itemName}
                        getUsersByAccountAndSoftware={
                          getUsersByAccountAndSoftware
                        }
                        htmlTemplate={templateBody}
                        page={index}
                        pageLength={remapData?.length}
                        setPageLength={setPageLength}
                        remapData={remapData}
                        setRemapData={setRemapData}
                      />
                    );
                  })
                ) : (
                  <ELetterPreview
                    fontStyle={fontStyle}
                    title={title}
                    previewDetail={previewDetail}
                    accountType={accountType}
                    docType={docType}
                    itemName={itemName}
                    getUsersByAccountAndSoftware={getUsersByAccountAndSoftware}
                    htmlTemplate={templateBody}
                    page={page}
                    pageLength={pageLength}
                    setPageLength={setPageLength}
                    remapData={remapData}
                    setRemapData={setRemapData}
                  />
                )
              ) : (
                <GPBodyTemplate
                  accountType={accountType}
                  fontStyle={fontStyle}
                  fontSize={fontSize}
                  descriptionSize={descriptionSize}
                  title={title}
                  docType={docType}
                  previewDetail={previewDetail}
                  getUsersByAccountAndSoftware={getUsersByAccountAndSoftware}
                  remapData={remapData}
                  page={page}
                  pageLength={remapData?.length}
                  companyCountry={user?.companyAddress?.Address?.country}
                />
              ))}
          </div>
        </div>
      </>
    );
  };

  const [openShareDialog, setOpenShareDialog] = useState(false);
  const [openSendEmail, setOpenSendEmail] = useState(false);

  const [
    getShareAttachments,
    {
      data: { getShareAttachment } = { getShareAttachment: {} as any },
      loading: ShareAttachmentLoading,
    },
  ] = useGetShareAttachmentMutation({
    onError: ({ message }) => {
      let error = message?.substring(15);
      setErrMessage(error);
      setErrDialog(true);
    },
    onCompleted: () => {
      setOpenShareDialog(true);
    },
  });

  const onSubmit = blob => {
    getShareAttachments({ variables: { file: blob, CompanyID: CompanyID } });
  };

  return (
    <>
      {UserLoading && <Loading />}
      {queryLoading && <Loading />}
      {ShareAttachmentLoading && <Loading />}
      <MainHeader
        mainBtn="back"
        onClick={() => {
          history.push(`/general-purchase/${CompanyID}/${backPath}`);
        }}
        smTitle={'General Purchases'}
        title={user?.companyName}
        routeSegments={[
          { name: `${smTitle}` },
          { name: `${routeSegments}` },
          { name: `${routeSegments}`, current: true },
        ]}
      />
      <ContentWrapper footer>
        <div
          style={eLetter === false ? { height: window.screen.height } : null}
        >
          <div style={eLetter === false ? styles.supercontainer : null}>
            <div style={eLetter === false ? styles.container : null}>
              {previewDetail &&
                (eLetter === true ? (
                  !!remapData && remapData?.length > 0 ? (
                    <ELetterPreview
                      title={title}
                      previewDetail={remapData[page]}
                      accountType={accountType}
                      docType={docType}
                      itemName={itemName}
                      getUsersByAccountAndSoftware={
                        getUsersByAccountAndSoftware
                      }
                      htmlTemplate={templateBody}
                      isView={true}
                      page={page}
                      pageLength={remapData?.length}
                      setPageLength={setPageLength}
                      remapData={remapData}
                      setRemapData={setRemapData}
                    />
                  ) : (
                    <ELetterPreview
                      title={title}
                      previewDetail={previewDetail}
                      accountType={accountType}
                      docType={docType}
                      itemName={itemName}
                      getUsersByAccountAndSoftware={
                        getUsersByAccountAndSoftware
                      }
                      htmlTemplate={templateBody}
                      isView={true}
                      page={page}
                      pageLength={pageLength}
                      setPageLength={setPageLength}
                      remapData={remapData}
                      setRemapData={setRemapData}
                    />
                  )
                ) : (
                  <GPBodyTemplate
                    accountType={accountType}
                    fontStyle={fontStyle}
                    fontSize={fontSize}
                    descriptionSize={descriptionSize}
                    title={title}
                    docType={docType}
                    previewDetail={previewDetail}
                    getUsersByAccountAndSoftware={getUsersByAccountAndSoftware}
                    remapData={remapData}
                    page={page}
                    pageLength={remapData?.length}
                    companyCountry={user?.companyAddress?.country}
                  />
                ))}
            </div>
          </div>
        </div>
        <div className={`pagination-dis-${width < 769 ? 'mobile' : 'desktop'}`}>
          <Pagination
            count={remapData?.length}
            shape="rounded"
            page={page + 1}
            onChange={(e, page) => {
              setCurrentPage(page - 1);
            }}
          />
        </div>
        {pdfToPrint()}
      </ContentWrapper>
      {ShareDialog({
        shareTitle: `General Purchases(${routeSegments}) - ${user?.companyName}`,
        title: `Share`,
        URL: getShareAttachment?.fileURL,
        setSimple: setOpenShareDialog,
        simple: openShareDialog,
        emailShare: openSendEmail,
        setSimpleEmail: setOpenSendEmail,
      })}
      <Footer
        options={[
          {
            name: 'Share',
            onClick: async () => {
              // const temp = document.getElementById('pdf-data-print');

              // if (!temp) {
              //   return;
              // }

              // try {
              //   const blob = await htmlToImage.toBlob(temp, {
              //     style: { background: '#fff' },
              //     cacheBust: true,
              //     filter: node => {
              //       if (node.tagName === 'IMG') {
              //         const img = node as HTMLImageElement;
              //         if (!img.complete || img.naturalHeight === 0) {
              //           return false;
              //         }
              //       }
              //       return true;
              //     },
              //     skipFonts: false,
              //   });

              //   onSubmit(blob);
              // } catch (error) {
              //   setErrMessage(
              //     'Failed to generate shareable image. Please try again.',
              //   );
              //   setErrDialog(true);
              // }
              onSubmit(await onShare());
            },
            color: 'primary',
            props: {
              type: 'submit',
            },
            startIcon: <ShareIcon style={{ fontSize: '18px' }} />,
          },
          {
            name: 'Download',
            onClick: () => {
              onPrint();
            },
            color: 'primary',
          },
        ]}
      />
      <ErrorDialog
        errorDia={errDialog}
        setErrorDia={setErrDialog}
        errorMsg={errMessage}
        errorHeaderMsg={'Error!'}
      />
      <ErrorDialog
        errorDia={errDia}
        setErrorDia={setErrDia}
        errorMsg={errMsg}
        errorHeaderMsg={'Error!'}
      />
    </>
  );
};
